/* @StringUtils class*/
import {ColorPicker} from '../../enums/color-picker.enum';

export class StringUtils {
    public static isEmpty (str: string): boolean {
        if (str == null || str === undefined || str.trim() === '') {
            return true;
        }
        return false;
    }

    public static isNotEmpty (str: string): boolean {
        return !this.isEmpty(str);
    }

    public static nvl (str: string, repl: string): string {
        if (this.isEmpty(str)) {
            return repl;
        }
        return str;
    }

    public static checkMinStr(val: any, min: any) {
        if (val !== undefined && val.trim().length < min) {
            return true;
        } else {
            return false;
        }
    }

    public static checkMaxStr(val: any, max: any) {
        if (val !== undefined && val.trim().length > max) {
            return true;
        } else {
            return false;
        }
    }

    public static checkMinMaxStr(val: any, min: any, max: any): boolean {
        if (this.checkMinStr(val, min) || this.checkMaxStr(val, max)) {
            return true;
        } else {
            return false;
        }
    }

    public static toBoolean (str: string): boolean {
        return str === 'true';
    }

    public static getUuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    public static strToDate (str: string): Date {
        return new Date();
    }

    public static getSundayOfMonth(d) {
        d = new Date(d);
        const day = d.getDay(),
            diff = d.getDate() - day + (day === 0 ? -6 : 0);
        return new Date(d.setDate(diff));
    }

    public static getDateofs(interval: number): string {
        let dateOfs = '2w';
        switch (interval) {
            case 1: dateOfs = '1d'; break;
            case 7: dateOfs = '1w'; break;
            case 14: dateOfs = '2w'; break;
            case 31: dateOfs = '1m'; break;
        }
        return dateOfs;
    }

    public static getCurrentDateStr(): string {
        const date = new Date();
        const fullYear = String(date.getFullYear());
        const month = date.getMonth() >= 9 ? String(date.getMonth() + 1) : '0' + String(date.getMonth() + 1);
        const day = date.getDate() >= 10 ? String(date.getDate()) : '0' + String(date.getDate());

        return `${fullYear}-${month}-${day}`;
    }

    public static getDate(str): Date {
        // 2018-12-31 12:00:00
        if (StringUtils.isEmpty(str)) {
            return new Date();
        }
        const tmp = str.split(' ');
        const date = tmp[0].split('-');
        const time = tmp[1].split(':');

        return new Date(Number(date[0]), (Number(date[1]) - 1), Number(date[2]), Number(time[0]), Number(time[1]));
    }

    public static getDateStr(date: Date): string {
        const fullYear = String(date.getFullYear());
        const month = date.getMonth() >= 9 ? String(date.getMonth() + 1) : '0' + String(date.getMonth() + 1);
        const day = date.getDate() >= 10 ? String(date.getDate()) : '0' + String(date.getDate());

        return `${fullYear}-${month}-${day}`;
    }

    public static getTimeStr(date: Date): string {
        const hours = date.getHours() >= 10 ? String(date.getHours()) : '0' + String(date.getHours());
        const minutes = date.getMinutes() >= 10 ? String(date.getMinutes()) : '0' + String(date.getMinutes());

        return `${hours}:${minutes}`;
    }

    //13:20이면 13:00 의 형식으로 분값은 버림
    public static getTimeStr2(date: Date): string {
        const hours = date.getHours() >= 10 ? String(date.getHours()) : '0' + String(date.getHours());
        const minutes = '00';

        return `${hours}:${minutes}`;
    }

    // 두 일자 간의 차이를 years, months, weeks, days, hours 로 반환
    public static diffTwoDate(fromDate: Date, toDate: Date, type?) {
        const fd = moment(fromDate);
        const td = moment(toDate);
        const duration = moment.duration(td.diff(fd));
        let diff;

        switch (type) {
            case 'Y': diff = duration.asYears(); break;
            case 'M': diff = duration.asMonths(); break;
            case 'W': diff = duration.asWeeks(); break;
            case 'D': diff = duration.asDays(); break;
            case 'H': diff = duration.asHours(); break;
        }
        return diff;
    }

    private static pad(num) {
        return ('0' + num).slice(-2);
    }

    public static getDdhhmmss(secs) {
        const seconds = secs % 60;
        let minutes = Math.floor(secs / 60);
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        const days = Math.floor(hours / 24);
        hours = hours % 24;

        return {days: days, hours: hours, minutes: minutes, seconds: seconds};
    }

    public static maskingPhoneNo(no: string) {
        return no.substr(0, no.length - 8) + '****' + no.substr(no.length - 4, 4);
    }

    public static isEmail(email: string) {
        const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegExp.test(email);
    }

    public static maskingEmail(email: string) {
        // @ 앞 3자리 마스킹 처리
        return email.replace(new RegExp('.(?=.{0,' + 2 + '}@)', 'g'), '*');
    }

    public static maskingStr(str: string, length: number) {
        return str.substr(0, length) + '****';
    }

    // 숫자 천단위 콤마 추가
    public static numberWithCommas(x: number) {
        if (x === undefined) {
            return '0';
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    public static getColor(num: number): string {
        let color = '';
        switch (num) {
            case 0:  color = ColorPicker.C95AAE6; break;
            case 1:  color = ColorPicker.C63CFC7; break;
            case 2:  color = ColorPicker.CE47BCC; break;
            case 3:  color = ColorPicker.CDDC79A; break;
            case 4:  color = ColorPicker.C9ECA78; break;
            case 5:  color = ColorPicker.C65BEE5; break;
            case 6:  color = ColorPicker.CF0AA80; break;
            case 7:  color = ColorPicker.CC6D763; break;
            case 8:  color = ColorPicker.CAC88EE; break;
            case 9:  color = ColorPicker.CC3BE7A; break;
            case 10: color = ColorPicker.C8099E1; break;
            case 11: color = ColorPicker.C55C6BC; break;
            case 12: color = ColorPicker.CDF6AC2; break;
            case 13: color = ColorPicker.CD7BC86; break;
            case 14: color = ColorPicker.C8BC067; break;
            case 15: color = ColorPicker.C57B2E0; break;
            case 16: color = ColorPicker.CEE996E; break;
            case 17: color = ColorPicker.CBBCF55; break;
            case 18: color = ColorPicker.C9C75EB; break;
            case 19: color = ColorPicker.CB8B169; break;
            case 20: color = ColorPicker.C6B87D9; break;
            case 21: color = ColorPicker.C47BAAE; break;
            case 22: color = ColorPicker.CD658B5; break;
            case 23: color = ColorPicker.CCDAE71; break;
            case 24: color = ColorPicker.C77B355; break;
            case 25: color = ColorPicker.C48A3D7; break;
            case 26: color = ColorPicker.CE8875B; break;
            case 27: color = ColorPicker.CADC447; break;
            case 28: color = ColorPicker.C8A61E4; break;
            case 29: color = ColorPicker.CA9A157; break;
            case 30: color = ColorPicker.C5674D0; break;
            case 31: color = ColorPicker.C39AEA1; break;
            case 32: color = ColorPicker.CCD47A9; break;
            case 33: color = ColorPicker.CC3A15C; break;
            case 34: color = ColorPicker.C62A645; break;
            case 35: color = ColorPicker.C3A94CE; break;
            case 36: color = ColorPicker.CE1744A; break;
            case 37: color = ColorPicker.C9FB939; break;
            case 38: color = ColorPicker.C784FDD; break;
            case 39: color = ColorPicker.C9C9247; break;
            case 40: color = ColorPicker.C4363C7; break;
            case 41: color = ColorPicker.C2DA295; break;
            case 42: color = ColorPicker.CC6389C; break;
            case 43: color = ColorPicker.CBA9548; break;
            case 44: color = ColorPicker.C4F9936; break;
            case 45: color = ColorPicker.C2E86C6; break;
            case 46: color = ColorPicker.CDA633A; break;
            case 47: color = ColorPicker.C93AF2D; break;
            case 48: color = ColorPicker.C683ED6; break;
            case 49: color = ColorPicker.C8F8537; break;
            default: color = ColorPicker.C444444; break;
        }
        return color;
    }

    public static getStrByte(str) {
        const stringByteLength = (function(s,b,i,c){
            for(b=i=0;c=s.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
            return b;
        })(str);
        return stringByteLength;
    }

    public static checkMaxStrByte(val: any, max: any) {
        if (val !== undefined && this.getStrByte(val.trim()) > max) {
            return true;
        } else {
            return false;
        }
    }

    public static cutStrByMaxByte(str, maxByte) {
        let size = 0;
        let rIndex = str.length;

        for ( let i = 0; i < str.length; i++) {
            size += this.getStrByte(str.charAt(i));
            if ( size === maxByte ) {
                rIndex = i + 1;
                break;
            } else if ( size > maxByte ) {
                rIndex = i;
                break;
            }
        }

        return str.substring(0, rIndex);
    };

    public static replaceAll(str, searchStr, replaceStr) {
        return str.split(searchStr).join(replaceStr);
    }

    public static addUrlLink(str) {
        const exp = /(\b(https|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;()']*[-A-Z0-9+&@#\/%=~_|)])/ig;
        return str.replace(exp, `<a href='$1' target='_blank'>$1</a>`);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/string.utils.ts